import React, { Component } from 'react'
import { connect } from 'react-redux';
import '../../../App.css';

import List from '@material-ui/core/List';

import DialogAction from '../../../componets/DialogAction.jsx';
import DialogPanel from '../../../componets/DialogPanel.jsx';

import * as SellerAction from '../../../actions/Actions_SellerManager';

import SellerTypeCard from './SellerTypeCard';
import SellerTypeListPanel from './SellerTypeListPanel';
import { init_sellerType } from '../../../constant/initState/initSellerType';

import { InitWaitingTime, SetStateWithTime, SetStateWithObject } from '../../../common/SetTime.js';

let SellerTypeList = [];
let waitingTime = true;
const _height = (window.innerHeight - 130);

class SellerTypeManage extends Component {
    state = { isLoading: true, msgError: undefined, dialogType: undefined, }
    constructor(props) {
        let error = null;
        super(props);
        this.state = {
            SellerTypeInfo: undefined,
            oldSellerTypeInfo: null,
            isCreate: false,
            isEdit: false,
            isView: false,
        }
        this.props.getSellerTypeList({ num_limit: 10 });
    }

    componentWillReceiveProps(nextProps) {
        // console.log('nextProps', nextProps);
        const { SellerManager } = nextProps;
        if (!!SellerManager) {

            const { actions, data } = SellerManager.SELLER_REDUCER;

            switch (actions) {
                case SellerAction.GET_SELLER_TYPE_SUCCESS:
                    {
                        SellerTypeList = data.result;
                        SetStateWithTime(this, waitingTime);
                    } break;
                case SellerAction.GET_SELLER_TYPE_FAILURE:
                    {
                        SetStateWithTime(this, waitingTime);
                    } break;
            }
        }
    }

    render() {
        const { isLoading, isCreate } = this.state;
        // console.log('SellerTypeList', SellerTypeList);
        return (
            <div className="App">
                {(isCreate) && <DialogAction Active={isCreate} OnClose={this.onClosePanel} AcrionCom={this.createSellerType()} />}
                {(isLoading) && <DialogPanel Active={isLoading} />}
                <List style={{ width: '100%', position: 'relative', overflow: 'auto' }}>
                    {/* <List style={{ width: '100%', position: 'relative', overflow: 'auto' ,height:_height}}> */}
                    <div style={{ display: 'inline-block' }}>
                        {this.contentPanel()}
                    </div>
                </List>
            </div>
        )
    }
    contentPanel() {
        return (
            // <div style={{ height: '600px', width: '100%', maxWidth: '1024px', }}>
            <div style={{ width: '100%', maxWidth: '1024px', }}>
                <SellerTypeListPanel
                    SellerTypeList={SellerTypeList}
                    CreatePanel={this.onCreatePanel(this.state.isCreate)}
                    EditInfo={this.editPanel()}
                    ViewInfo={this.viewInfo()} />
            </div>)
    }

    createSellerType = () => {
        const { isEdit, SellerTypeInfo, oldSellerTypeInfo, isView } = this.state;
        return (
            <SellerTypeCard
                SellerTypeList={SellerTypeList}
                onChangeLanguage={this.onChangeLanguage}
                isEdit={isEdit}
                isView={isView}
                SellerTypeInfo={SellerTypeInfo}
                oldSellerTypeInfo={oldSellerTypeInfo}
                onClosePanel={this.onClosePanel}
            />
        )
    }

    onCreatePanel = (_isActive) => () => (this.setState({ isCreate: !_isActive, isEdit: false, isView: false, oldSellerTypeInfo: { ...init_sellerType }, SellerTypeInfo: { ...init_sellerType } }));
    onClosePanel = () => (this.setState({ isCreate: false, isEdit: false, isView: false, SellerTypeInfo: undefined, }));
    onCloseDialog = () => (this.setState({ isLoading: false, msgError: undefined, dialogType: undefined }));

    onChangeLanguage = (_language) => {
        const { page } = SellerTypeList;
        console.log('_language', _language);
        this.props.getSellerTypeList({ page: page, num_limit: 10, language: _language });
    }

    editPanel = () => (SellerTypeInfo) => {
        this.setState({
            isCreate: true,
            isEdit: true,
            isView: false,
            SellerTypeInfo,
            oldSellerTypeInfo: SellerTypeInfo
        })
    }

    viewInfo = () => (SellerTypeInfo) => {
        this.setState({
            isCreate: true,
            isView: true,
            SellerTypeInfo,
            oldSellerTypeInfo: SellerTypeInfo
        })
    }

}
function mapStateToProps(state, ownProps) {
    return { ...state };
}

function mapDispatchToProps(dispatch) {
    return {
        getSellerTypeList: (_keyword, _filter) => {
            InitWaitingTime();
            dispatch(SellerAction.getSellerTypeList(_keyword, _filter));
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SellerTypeManage);